import React from "react";
import Skeleton from "react-loading-skeleton";

function FavorisPageSkeleton() {
  return (
    <div className="row">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 mb-24"
        >
          <div className="card">
            <Skeleton height={160} width="100%" />
            <div className="p-3">
              <Skeleton width="80%" height={20} />
              <Skeleton width="60%" height={16} style={{ marginTop: 8 }} />
              <Skeleton width="40%" height={14} style={{ marginTop: 4 }} />
              <Skeleton width="90%" height={14} style={{ marginTop: 8 }} />
              <div className="d-flex justify-content-between mt-2">
                <Skeleton width={40} height={40} circle />
                <Skeleton width={40} height={40} circle />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default FavorisPageSkeleton;
